// extracted by mini-css-extract-plugin
export default {"games-page":"WtJLthP-dKelL3AtxPbDjQ==","game-page":"WNrugaQ2Fz9-wYJNoXTYXA==","game-loader":"bqx8oho7NB3Np4KdrOyIqQ=="};